import { createSelector } from '@ngrx/store';
import { AppStateInterface } from '../types';

export const selectSettingsData = (state: AppStateInterface) =>
  state.settingsData;

export const isLaodingsettingsDataSelector = createSelector(
  selectSettingsData,
  (state) => state.isLoading,
);
export const successSettingsDataSelector = createSelector(
  selectSettingsData,
  (state) => state.settingsData,
);
export const errorSettingsDataSelector = createSelector(
  selectSettingsData,
  (state) => state.error,
);
